export class StringHelper {
    public static pad(str, len, inverse = false) {
        const pad = '0000';
        str = '' + str;
        return (inverse) ? str + pad.substr(0, len - str.length) : pad.substr(0, len - str.length) + str;
    }
}